import { IPDFConfig, IPDFIndexedConfig } from '../pdf-cart/types/pdfConfig';

const w: any = window;

class SlideShowService {
    showModal(content: string) {
        w._ameri.slideshow.showModal(content);
    }

    hideModal() {
        w._ameri.slideshow.hideModal();
    }

    viewPDF(pdfConfig: IPDFConfig): Promise<string> {
        return w._ameri.slideshow._onPDFView(pdfConfig);
    }

    viewIndexedPDF(pdfConfig: IPDFIndexedConfig): Promise<string> {
        return w._ameri.slideshow._onIndexedPDFView(pdfConfig);
    }

    get slideshow(): any {
        return w._ameri?.slideshow;
    }

    get currentChapterController(): any {
        return w._ameri?.slideshow?._model.getChapter(w._ameri?.slideshow?._state.currentNavigation.chapter);
    }

}

const slideShowService = new SlideShowService();
export default slideShowService;
